import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';

import { FireIcon, TimeIcon } from 'icons';

import { useStyles } from './styles';

const Timer = (props: any) => {
  const { data, isSeconds, reload, isicon } = props;

  const { classes, cx } = useStyles();

  const [hours, setHours] = useState(data?.timer?.hours);
  const [minutes, setMinutes] = useState(data?.timer?.minutes);
  const [seconds, setSeconds] = useState(data?.timer?.seconds);

  useEffect(() => {
    const myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }

      if (seconds === 0) {
        if (hours === 0 && minutes === 0) {
          clearInterval(myInterval);
          reload && window.location.reload();
        } else {
          setSeconds(59);

          if (hours >= 0) {
            if (minutes > 0) {
              setMinutes(minutes - 1);
            }
            if (minutes === 1 && hours === 0) {
              setMinutes(0);
              setHours(0);
              setSeconds(59);
            }
            if (minutes === 1 && hours !== 0) {
              setMinutes(59);
              setHours(hours - 1);
            }
          }
        }
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  });

  const isExpired = hours === 0 || hours === 1;

  const fullTime = `${hours}h: ${minutes}m: ${seconds}s`;
  const shortTime = `${hours}h: ${minutes}m`;

  return isicon ? (
    <div
      className={cx(classes.wrapper, {
        [classes.expired]: !isExpired,
        [classes.time]: isExpired,
      })}
    >
      {isExpired ? <FireIcon className={classes.icon} /> : <TimeIcon className={classes.icon} />}
      <Typography variant="h3">{isSeconds ? fullTime : shortTime}</Typography>
    </div>
  ) : (
    <div className={classes.wrapper}>
      <Typography variant="h3">{isSeconds ? fullTime : shortTime}</Typography>
    </div>
  );
};

Timer.defaultProps = {
  isSeconds: true,
  reload: true,
  isicon: true,
};

export default Timer;
